///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { SuiUserDTO } from '../../generated/shared-sui-types.model';
import { UserDTO } from '../../generated/shared-types.model';

export class UpdatedSuiUserDTO extends SuiUserDTO {
    isHighlighted: boolean;

    constructor(data: UserDTO, isHighlighted?: boolean) {
        super(data);
        this.isHighlighted = isHighlighted || false;
    }
}
